// START GENAI
import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'vs-card-3up',
  styleUrl: 'vs-card-3up.scss',
  shadow: false,
})
export class Card3up {
  /** Array of card objects - must have at least 3 */
  @Prop() cards: any[] = [];

  /** Common props passed to each vsr-card */
  @Prop() borderRadius: string;
  @Prop() animation: string;
  @Prop() imageVariant: string = 'variant1';
  @Prop() cardVariant: string;
  @Prop() theme: 'light' | 'dark' = 'light';
  @Prop() imageAspectRatio: string = '3:4';

  /** Event emitted when compare is clicked */
  @Event() compareClicked: EventEmitter<{ card: any; index: number }>;

  private handleCompare(card, idx) {
    this.compareClicked.emit({ card, index: idx });
  }

  render() {
    // Safety check
    if (!this.cards || this.cards.length < 3) {
      return <div>Insufficient cards provided for 3up layout</div>;
    }

    return (
      <div class="vs-content-card__3up-container" role="grid">
        <div class="vs-content-card__3up-wrapper">
          {this.cards.slice(0, 3).map((card, idx) => (
            <div class="vs-content-card__3up-card" role="gridcell">
              <vsr-card
                type={card.type}
                image-url={card.imageUrl}
                borderRadius={this.borderRadius}
                animation={this.animation}
                imageVariant={`3up-${idx}`}
                imageAspectRatio={card.imageAspectRatio || this.imageAspectRatio}
                cardVariant={this.cardVariant}
                cardLink={card.cardLink}
                cardLinkTarget={card.cardLinkTarget}
                imageAltText={card.imageAltText}
                title={card.title || ''}
                description={card.description || ''}
                cardCta={card.cardCta}
                button-text-2={card.buttonText2}
                key={`${card.title || 'card'}+${idx}`}
                onCompareClicked={() => this.handleCompare(card, idx)}
                theme={this.theme}
                media-src={card.videoUrl}
                poster={card.imageUrl}
                media-type={
                  card.mediaType == 'image'
                    ? 'image'
                    : card.mediaType == 'ambient-video-static'
                      ? 'single'
                      : 'loop'
                }
                video-alt={card.imageAltText}
              ></vsr-card>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

// END GENAI
